import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';

import { ModalSto } from 'components/sto';

const OTPResentModal = (props) => (
    <ModalSto
        buttonSize="large"
        isCTA={false}
        modalType="resendCode"
        okText="general.ok"
        onOk={props.onOk}
        visible={props.visible}
        wrapClassName="otp-resent-modal"
    >
        <React.Fragment>
            {props.otpSent ? (
                <React.Fragment>
                    <h3 className="resend-popup">
                        <FormattedMessage id="pages.OTP.resendCode" />
                    </h3>
                    <p className="resend-email">{props.email}</p>
                    <hr className="solid" />
                    <p>
                        <FormattedMessage id="pages.OTP.resendCode.message.first.line" />
                    </p>
                    <p>
                        <FormattedMessage id="pages.OTP.resendCode.message.second.line" />
                    </p>
                </React.Fragment>
            ) : (
                <p>
                    <FormattedMessage id="pages.OTP.resendFailure" />
                </p>
            )}
        </React.Fragment>
    </ModalSto>
);

export default injectIntl(OTPResentModal);
